import { render, staticRenderFns } from "./SimulationCard.vue?vue&type=template&id=3806e5ee"
import script from "./SimulationCard.vue?vue&type=script&lang=js"
export * from "./SimulationCard.vue?vue&type=script&lang=js"
import style0 from "./SimulationCard.vue?vue&type=style&index=0&id=3806e5ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports